import angular from 'angular';

SiteGroupEditionController.$inject = ['$scope', '$state', '$stateParams', '$mdDialog', 'TopToolbarFactory', 'SitesGroupFactory', 'AccountsFactory', 'AlertingFactory', 'StrategiesFactory',
  'siteGroups', 'siteGroupsMap', 'sites', 'sitesMap', 'ConfirmationFactory', 'AngularSitesService'];
export function SiteGroupEditionController($scope, $state, $stateParams, $mdDialog, TopToolbarFactory, SitesGroupFactory, AccountsFactory, AlertingFactory, StrategiesFactory,
  siteGroups, siteGroupsMap, sites, sitesMap, ConfirmationFactory, AngularSitesService) {

  $scope.goBack = goBack;
  $scope.onSave = onSave;
  $scope.onNameChange = onNameChange;
  $scope.onAddSiteClick = onAddSiteClick;
  $scope.onRemoveSiteClick = onRemoveSiteClick;
  $scope.hrefAccountInfo = hrefAccountInfo;
  $scope.siteGroup = siteGroupsMap.get(+$stateParams.id);

  // Go to site
  function hrefAccountInfo(accountId) {
    return AccountsFactory.hrefAccountInfo($state, accountId);
  }

  // Go back to Groups table
  function goBack() {
    SitesGroupFactory.redirectToGroupsPage();
  }

  function updateInfo(name, siteIds) {
    $scope.infoHasChanged = true;
    SitesGroupFactory.updateSiteGroup($stateParams.companyId, $scope.siteGroup.id, name, siteIds)
      .then(response => {
        siteGroups.refresh().then(() => {
          siteGroupsMap.refresh();
          const result = response.data;
          // TODO refactor with sites service function
          (Object.keys(result.sites) || []).forEach((siteId) => {
            const site = result.sites[+siteId];
            const siteFormatted = AngularSitesService.formatSiteV2({
              site,
              id: +siteId,
              siteGroupId: result.id,
              type: result.type,
            });
            result.sites[+siteId] = siteFormatted;
          })


          $scope.siteGroup = angular.copy(result);
          onSiteGroupUpdate();
          AlertingFactory.success('groups/update_group_success');
          sites.refresh().then(() => {
            sitesMap.refresh();
          });
        });
      }).catch(
        AlertingFactory.httpErrorHandler()
      ).finally(() => {
        $scope.infoHasChanged = false;
      });
  }

  function onSave() {
    const siteIds = Object.keys($scope.siteGroup.sites);
    updateInfo($scope.siteGroup.name, siteIds);
  }

  function onNameChange() {
    $scope.infoHasChanged = true;
  }


  function onAddSiteClick() {
    let compatibleSites = sites.filter(site => site.type == $scope.siteGroup.type && !(site.id in $scope.siteGroup.sites) && !(site.site_group_id || site.site_group));
    $mdDialog.show({
      'controller': 'AddSiteToGroupController',
      'template': require('./site-group-add-site.dialog.html'),
      'targetEvent': event,
      'clickOutsideToClose': false,
      'locals': {
        addableSites: compatibleSites,
        StrategiesFactory: StrategiesFactory
      }
    })
      .then(function (addedSiteIds) {
        const siteIds = Object.keys($scope.siteGroup.sites);
        addedSiteIds.forEach(siteId => {
          siteIds.push(siteId);
        });
        updateInfo($scope.siteGroup.name, siteIds);
      });
  }

  function onRemoveSiteClick(removeSiteId) {
    ConfirmationFactory.materialConfirmDialog('parameters/group-account/confirm-deletion')
      .then(() => {
        const siteIds = Object.keys($scope.siteGroup.sites).filter(siteId => siteId != removeSiteId);
        updateInfo($scope.siteGroup.name, siteIds);
      });
  }


  function onSiteGroupUpdate() {
    TopToolbarFactory.setTitle($scope.siteGroup.name, $scope);
    $scope.siteGroup.platformIconClass = 'alc-site-icon-inline bg-img-' + $scope.siteGroup.type_name;
  }

  init();

  function init() {
    TopToolbarFactory.setFirstLevelNavTranslation('parameters/links_menu/groups', $scope, () => SitesGroupFactory.redirectToGroupsPage());
    onSiteGroupUpdate();
  }
}
